import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import icons from '../icons';
import Input from './Input';
import { inputClass } from './styles';
import { isRTL } from '../config';
import { sub } from '../utils/numbers';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = {
  step: 1,
  allowNull: false,
  hideArrow: false
};

var Number =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Number, _PureComponent);

  var _super = _createSuper2(Number);

  function Number(props) {
    var _this;

    _classCallCheck(this, Number);

    _this = _super.call(this, props);
    _this.hold = void 0;
    _this.handleAddClick = void 0;
    _this.handleSubClick = void 0;
    _this.keyPressTimeOut = void 0;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleAddClick = _this.handleCalc.bind(_assertThisInitialized(_this), props.step);
    _this.handleSubClick = _this.handleCalc.bind(_assertThisInitialized(_this), -props.step);
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Number, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hold = false;
      if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
    } // handleChange(value: NumberValue) {
    //   this.handleChange(NumberValue)
    // }

  }, {
    key: "handleChange",
    value: function handleChange(value, check, isEmpty) {
      if (isEmpty || value === undefined) {
        this.props.onChange(value);
        return;
      }

      if (!check) {
        if (new RegExp('^-?\\d*\\.?\\d*$').test(value)) {
          this.props.onChange(value);
        }

        return;
      }

      var _this$props = this.props,
          digits = _this$props.digits,
          _this$props$step = _this$props.step,
          step = _this$props$step === void 0 ? DefaultValue.step : _this$props$step,
          numType = _this$props.numType,
          _this$props$allowNull = _this$props.allowNull,
          allowNull = _this$props$allowNull === void 0 ? DefaultValue.allowNull : _this$props$allowNull;

      if (numType === 'positive' && value <= 0) {
        value = allowNull ? null : undefined;
      } else if (typeof digits === 'number') {
        value = parseFloat(value.toFixed(digits));
      } else {
        var stepStr = step.toString();
        var dot = stepStr.lastIndexOf('.');
        if (dot >= 0) value = parseFloat(value.toFixed(stepStr.length - dot));
      }

      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max;
      if (max !== undefined && value > max) value = max;
      if (min !== undefined && value < min) value = min;

      if (value !== this.props.value) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      this.hold = false;
      var value = parseFloat(e.target.value); // for the empty

      if (e.target.value === '' && this.props.allowNull) {
        value = null;
      } // eslint-disable-next-line no-restricted-globals


      if (isNaN(value)) value = 0;

      if (this.props.clearToUndefined && e.target.value === '' && this.props.value === undefined) {
        this.handleChange(undefined, true, true);
      } else {
        this.handleChange(value, true, value === null);
      }

      this.props.onBlur(e);
    }
  }, {
    key: "changeValue",
    value: function changeValue(mod) {
      if (this.props.disabled) return;
      var val = this.props.value;
      if (val === 0) val = '0';
      var value = parseFloat("".concat(val || '').replace(/,/g, '')); // eslint-disable-next-line

      if (isNaN(value)) value = 0;
      var _this$props3 = this.props,
          numType = _this$props3.numType,
          integerLimit = _this$props3.integerLimit;
      var calculateVal = sub(value, mod);

      if (numType === 'positive' && calculateVal <= 0) {
        return;
      }

      if (numType === 'non-negative' && calculateVal < 0) {
        return;
      }

      if (integerLimit && String(parseInt(calculateVal, 10)).length > integerLimit) {
        return;
      }

      this.handleChange(calculateVal, true);
    }
  }, {
    key: "longPress",
    value: function longPress(mod) {
      var _this2 = this;

      if (!this.hold) return;
      setTimeout(function () {
        _this2.changeValue(mod);

        _this2.longPress(mod);
      }, 50);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this3 = this;

      var _this$props$step2 = this.props.step,
          step = _this$props$step2 === void 0 ? DefaultValue.step : _this$props$step2;
      this.hold = true;
      if (e.keyCode !== 38 && e.keyCode !== 40) return;
      e.preventDefault();
      var mod = e.keyCode === 38 ? step : -step;
      this.changeValue(mod);
      if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
      this.keyPressTimeOut = setTimeout(function () {
        _this3.longPress(mod);
      }, 600);
    }
  }, {
    key: "handleCalc",
    value: function handleCalc(mod, e) {
      var _this4 = this;

      var onMouseDown = this.props.onMouseDown;
      if (onMouseDown) onMouseDown(e);
      this.hold = true;
      this.changeValue(mod);
      this.keyPressTimeOut = setTimeout(function () {
        _this4.longPress(mod);
      }, 1000);
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp() {
      this.hold = false;
      if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(e) {
      var onMouseUp = this.props.onMouseUp;
      if (onMouseUp) onMouseUp(e);
      this.hold = false;
      if (this.keyPressTimeOut) clearTimeout(this.keyPressTimeOut);
    }
  }, {
    key: "renderArrowGroup",
    value: function renderArrowGroup() {
      var hideArrow = this.props.hideArrow;
      if (hideArrow) return [];
      return [
      /*#__PURE__*/
      React.createElement("a", {
        key: "up" // do not need the tab to focus
        ,
        tabIndex: -1,
        className: inputClass('number-up'),
        onMouseDown: this.handleAddClick,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseUp
      }, icons.AngleRight),
      /*#__PURE__*/
      React.createElement("a", {
        key: "down" // do not need the tab to focus
        ,
        tabIndex: -1,
        className: inputClass('number-down'),
        onMouseDown: this.handleSubClick,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseUp
      }, icons.AngleRight)];
    }
  }, {
    key: "renderRTL",
    value: function renderRTL() {
      var _this$props4 = this.props,
          onChange = _this$props4.onChange,
          allowNull = _this$props4.allowNull,
          hideArrow = _this$props4.hideArrow,
          value = _this$props4.value,
          defaultValue = _this$props4.defaultValue,
          other = _objectWithoutProperties(_this$props4, ["onChange", "allowNull", "hideArrow", "value", "defaultValue"]);

      return [].concat(_toConsumableArray(this.renderArrowGroup()), [
      /*#__PURE__*/
      React.createElement(Input, Object.assign({
        key: "input",
        value: value
      }, other, {
        className: inputClass(!hideArrow && getDirectionClass('number'), 'rtl'),
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        cancelBlurChange: true,
        type: "number"
      }))]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          onChange = _this$props5.onChange,
          allowNull = _this$props5.allowNull,
          hideArrow = _this$props5.hideArrow,
          defaultValue = _this$props5.defaultValue,
          value = _this$props5.value,
          other = _objectWithoutProperties(_this$props5, ["onChange", "allowNull", "hideArrow", "defaultValue", "value"]);

      var rtl = isRTL();

      if (rtl) {
        return this.renderRTL();
      }

      return [
      /*#__PURE__*/
      React.createElement(Input, Object.assign({
        key: "input",
        value: value
      }, other, {
        className: inputClass(!hideArrow && getDirectionClass('number')),
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        cancelBlurChange: true,
        type: "number"
      }))].concat(_toConsumableArray(this.renderArrowGroup()));
    }
  }]);

  return Number;
}(PureComponent);

Number.defaultProps = DefaultValue;
export default Number;